<template>
  <v-container fluid class="location-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Location</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Photo</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Location</p>
                        <v-text-field
                          class="mb-4"
                          type="Number"
                          v-model="new_location.locationrank"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Location Rank"
                          persistent-hint
                          single-line hint="Enter the location rank">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="new_location.locationcode"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Location Code"
                          persistent-hint
                          single-line hint="Enter the location Code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="new_location.locationname"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Location Name"
                          persistent-hint
                          single-line hint="Enter the location name">
                        </v-text-field>
                        <v-switch
                            v-model="new_location.locationstatus"
                            color="primary"
                            v-bind:label="new_location.locationstatus"
                            value="Active"
                        ></v-switch>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items=items
                          v-model="new_location.locationtype"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the location type">
                        </v-select>
                        <v-text-field
                          class="mb-4"
                          v-model="new_location.locationinfo"
                          outlined
                          dense
                          placeholder="Location Info"
                          persistent-hint
                          single-line hint="Enter the location info">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="new_location.geolocation"
                          outlined
                          dense
                          placeholder="Geolocation"
                          persistent-hint
                          single-line hint="Enter the geolocation">
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-textarea
                          outlined
                          v-model="new_location.locationaddress"
                          rows="3"
                          label="Location Address"
                          hint="please enter the location address"
                        ></v-textarea>
                        <v-select
                          class="mb-4"
                          :items="regions.map(x => {
                              return {text: x.regionname, value: x._id};
                            })"
                          v-model="new_location.regionid"
                          outlined
                          dense
                          placeholder="Region"
                          persistent-hint
                          single-line hint="Please choose the region">
                        </v-select>
                        <v-text-field
                          class="mb-4"
                          v-model="new_location.locationphone"
                          outlined
                          dense
                          placeholder="Location Phone"
                          persistent-hint
                          single-line hint="Enter the location phone">
                        </v-text-field>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md=9>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/location/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Upload Photo</p>
                        <p>Photo:</p>

                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertLocation()">
                            Save
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      imageurl: undefined,
      new_location: {},
      items: ['Head Office', 'Distribution Center', 'Warehouse', 'Depot', 'Outlet', 'Other'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },
  computed: {
    ...mapState('Location', ['isReceiving']),
    ...mapState('Region', ['regions'])
  },
  methods: {
    ...mapActions('Location', ['insertLocationRequest','getLocationsRequest']),
    ...mapActions('Region', ['getRegionsRequest']),
    checkError(){
      if(!this.new_location.locationrank){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.new_location.locationcode){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.new_location.locationname){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.new_location.locationtype){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    async insertLocation() {
      await this.insertLocationRequest(this.new_location)
      router.push('/location/list')
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.new_location.locationimage = file;
      this.new_location.imagename = file.name;
      this.createImage(file);
    }
  },
  async created () {
    if(this.regions.length==0) await this.getRegionsRequest();
  },

}
</script>

<style src="./Add.scss" lang="scss"></style>
